import { C } from '../../theme';
import type { Theme } from '../theme-contexte';

/**
 * Choisir l'apparence de Colette (handoff Horizon, § Ecrans 5).
 *
 * Quatre choix explicites plutot qu'un bouton qui cycle : la pastille d'Aujourd'hui
 * cycle deja, et un reglage doit montrer TOUTES ses valeurs — on ne devine pas ce qu'un
 * bouton va donner au troisieme appui.
 *
 * `Auto` n'est pas une couleur, c'est une regle : nuit de 19 h a 7 h, dans le fuseau du
 * FOYER. La carte le dit, sinon le mot ne veut rien dire.
 */

const CHOIX: { valeur: Theme; libelle: string }[] = [
  { valeur: 'auto', libelle: 'Auto' },
  { valeur: 'jour', libelle: 'Jour' },
  { valeur: 'nuit', libelle: 'Nuit' },
  { valeur: 'blanc', libelle: 'Blanc' },
];

export function CarteApparence({
  libelle,
  choix,
  onChanger,
}: {
  libelle: string;
  choix: Theme;
  onChanger: (theme: Theme) => void;
}) {
  return (
    <div
      style={{
        background: C.carte,
        border: `1px solid ${C.bordure}`,
        borderRadius: 18,
        padding: '14px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.encre }}>Apparence</div>
          <div style={{ fontSize: 12, color: C.secondaire, lineHeight: 1.4 }}>
            « Auto » suit l’heure du foyer : nuit de 19 h à 7 h.
          </div>
        </div>
        <div
          style={{
            background: C.accentDoux,
            color: C.accent,
            borderRadius: 999,
            padding: '4px 10px',
            fontSize: 12,
            fontWeight: 800,
            flexShrink: 0,
          }}
        >
          {libelle}
        </div>
      </div>

      <div
        role="radiogroup"
        aria-label="Apparence de Colette"
        style={{
          display: 'flex',
          gap: 4,
          background: C.carteDouce,
          border: `1px solid ${C.bordure}`,
          borderRadius: 999,
          padding: 4,
        }}
      >
        {CHOIX.map((option) => {
          const actif = option.valeur === choix;
          return (
            <button
              key={option.valeur}
              type="button"
              role="radio"
              aria-checked={actif}
              onClick={() => onChanger(option.valeur)}
              style={{
                flex: 1,
                height: 34,
                border: 'none',
                borderRadius: 999,
                background: actif ? C.carteForte : 'transparent',
                color: actif ? C.encre : C.tertiaire,
                fontSize: 13,
                fontWeight: 800,
                fontFamily: 'inherit',
                cursor: 'pointer',
                transition: 'background 0.2s, color 0.2s',
              }}
            >
              {option.libelle}
            </button>
          );
        })}
      </div>
    </div>
  );
}
